import React from 'react'

import logoUmbra from './../../../UI/general/Sidebar/logo-umbra.svg'

import {familiasData } from './../../../data/familias' 

import backgroundBtn from './../../../UI/general/Sidebar/sidebar-btn.png'
import backBtn from './../../../UI/general/Sidebar/back-btn.svg'

interface Props{
    isMenuOpened: boolean
    handleFamilyBtnClick: any
    handleBackBtn: any
    isFamilias: boolean
    isFamiliaSelected: boolean
    selectedBikeFamily: any
    handleBike: any
}

interface props{

}

class SidebarDesktop extends React.Component<Props, props>{
    constructor(props: Props){
        super(props);

    }

    handleBuildFamilyStructure = () => {
        return(
            familiasData()[0].Familias.map((familia: any, index: number) => 
                <div key={index} className="familia-individual-container">
                    <div className="familia-nombre">{familia.Familia}</div>
                    {familia.Motos.map((motos: any, indexMoto: number) => 
                        <div className="familia-btn" onClick = {() => {this.props.handleFamilyBtnClick(motos.Moto)}}>
                            <img src={backgroundBtn} className="background-familiar-btn"/>
                            <img src={motos.Logo.default} className="logo-familia-moto"/>
                        </div>
                    )}
                </div>
            )
        )
    }
    
    handleBuildMotosStructure = () => {
        return(
            this.props.selectedBikeFamily.Motos.map((motos: any, index: number) =>
            <div className="moto-btn" onClick={() => {this.props.handleBike(motos)}}>
                <img src={backgroundBtn} className="background-familiar-btn moto-background"/>
                <div className='moto-info-container'>
                    <img src={motos.Logo.default} className="logo-individual-moto"/>
                    <img src={motos.Foto.default} className="foto-individual-moto"/>
                </div>
            </div>
            )
        )
    }

    render(){
        return(
            <div className={this.props.isMenuOpened ? "sidebar-opened-desktop":"sidebar-collapsed-desktop"}>
                {
                    this.props.isFamilias && this.props.isMenuOpened ?
                    <div className="familias-container">
                        <div className="familias-title">FAMILIAS</div>
                        <hr className="familias-hr"/>
                        <div className="familias-btn-container">
                            {
                                this.handleBuildFamilyStructure()
                            }
                        </div>
                        <div className="logo-umbra-container">
                            <div>Powered by</div>
                            <img src={logoUmbra} alt=""/>
                        </div>
                    </div>:null
                }
                {
                    this.props.isFamiliaSelected && this.props.isMenuOpened ?
                    <div className="familias-container">
                        <div className='motos-title-container'>
                            <img src={backBtn} className='back-btn' onClick={() => {this.props.handleBackBtn()}} alt=""/>
                            <img src={this.props.selectedBikeFamily.Logo.default} className='familia-logo' alt=""/>
                        </div>
                        <hr className="familias-hr"/>
                        <div className="familias-btn-container">
                            {
                                this.handleBuildMotosStructure()
                            }
                        </div>
                        <div className="logo-umbra-container">
                            <div>Powered by</div>
                            <img src={logoUmbra} alt=""/>
                        </div>
                    </div>:null
                }
            </div>
        )
    }
}

export default SidebarDesktop